export default "__VITE_ASSET__Yy_vAzEQ__"